import s from "./Preloader.module.css";
import React from "react";

export function Preloader() {
    return <div className={s.loader}/>
}